// Belge tipleri için profesyonel varsayılan şablon layout'ları (banded designer formatında).
// Kullanıcı "+ Yeni Şablon" deyince bu layout DB'ye yazılır, sonra designer'da açar/düzenler.
// Tüm koordinatlar mm cinsinden (A4 portrait, 12mm kenar = 186x273mm çalışma alanı).

const TEXT = (id, band, x, y, w, h, text, opts = {}) => ({
  id, band, type: 'text', x, y, w, h, rotation: 0,
  align: opts.align || 'left', valign: opts.valign || 'middle',
  font_size: opts.font_size || 10,
  bold: !!opts.bold, italic: !!opts.italic, underline: !!opts.underline,
  color: opts.color || '#1a2332',
  text,
});

const FIELD = (id, band, x, y, w, h, data_source, field, opts = {}) => ({
  id, band, type: 'field', x, y, w, h, rotation: 0,
  align: opts.align || 'left', valign: opts.valign || 'middle',
  font_size: opts.font_size || 10,
  bold: !!opts.bold,
  color: opts.color || '#1a2332',
  data_source, field,
  format: opts.format || '',
});

const EXPR = (id, band, x, y, w, h, expression, opts = {}) => ({
  id, band, type: 'expression', x, y, w, h, rotation: 0,
  align: opts.align || 'left', valign: opts.valign || 'middle',
  font_size: opts.font_size || 10,
  bold: !!opts.bold,
  color: opts.color || '#1a2332',
  data_source: opts.data_source || 'main',
  expression,
  format: opts.format || '',
});

const LINE = (id, band, x, y, w, color = '#1d6ef5', thickness = 1) => ({
  id, band, type: 'line', x, y, w, h: 0.3, rotation: 0,
  color, thickness,
});

const RECT = (id, band, x, y, w, h, opts = {}) => ({
  id, band, type: 'rect', x, y, w, h, rotation: 0,
  border_color: opts.border_color || '#cbd5e1',
  border_width: opts.border_width != null ? opts.border_width : 0.5,
  background: opts.background || 'transparent',
});

// ─────────────────────────────────────────────────────────────────
// VERİLEN TEKLİF — Standart şablonu
// ─────────────────────────────────────────────────────────────────
export const SALES_QUOTE_STANDARD = {
  paper_size: 'A4',
  page_orientation: 'portrait',
  margin_top: 12, margin_bottom: 12, margin_left: 12, margin_right: 12,
  accent_color: '#1d6ef5',
  font_family: 'Arial, sans-serif',
  font_size: 10,
  group: { by_field: '', sort_dir: 'asc' },
  bands: {
    report_header: { height: 60, visible: true  },
    page_header:   { height: 10, visible: true  },
    group_header:  { height: 0,  visible: false },
    master:        { height: 0,  visible: false },
    detail:        { height: 8,  visible: true,  source: 'detail' },
    group_footer:  { height: 0,  visible: false },
    page_footer:   { height: 8,  visible: true  },
    report_footer: { height: 50, visible: true  },
  },
  data_sources: {
    main:   { name: 'Belge Başlığı', source_type: 'doc_header', fields: [] },
    detail: { name: 'Belge Satırı',  source_type: 'doc_line',   fields: [], master_key: 'id', detail_key: 'master_id' },
  },
  elements: [
    // ──── REPORT HEADER ─────────────────────────────────────────
    TEXT('rh_company', 'report_header', 2, 2, 100, 7, 'FİRMA ADI / SLOGAN',
      { font_size: 13, bold: true, color: '#1d6ef5' }),

    TEXT('rh_title', 'report_header', 0, 14, 186, 10, 'VERİLEN TEKLİF',
      { font_size: 18, bold: true, color: '#1d6ef5', align: 'center' }),

    LINE('rh_line1', 'report_header', 0, 26, 186, '#1d6ef5', 1.5),

    // Sol blok: belge bilgileri
    TEXT('rh_lbl_no',  'report_header', 2,  30, 28, 5, 'Belge No:',        { bold: true, font_size: 9 }),
    FIELD('rh_no',     'report_header', 32, 30, 60, 5, 'main', 'document_number', { font_size: 10, bold: true, color: '#1d6ef5' }),
    TEXT('rh_lbl_dt',  'report_header', 2,  36, 28, 5, 'Tarih:',           { bold: true, font_size: 9 }),
    FIELD('rh_dt',     'report_header', 32, 36, 60, 5, 'main', 'invoice_date',    { font_size: 10 }),
    TEXT('rh_lbl_vu',  'report_header', 2,  42, 28, 5, 'Geçerlilik:',      { bold: true, font_size: 9 }),
    FIELD('rh_vu',     'report_header', 32, 42, 60, 5, 'main', 'valid_until',     { font_size: 10 }),
    TEXT('rh_lbl_pr',  'report_header', 2,  48, 28, 5, 'Hazırlayan:',      { bold: true, font_size: 9 }),
    FIELD('rh_pr',     'report_header', 32, 48, 60, 5, 'main', 'personnel_name',  { font_size: 10 }),

    // Sağ blok: cari bilgileri
    RECT('rh_card_rect', 'report_header', 95, 28, 91, 28, { border_color: '#e2e8f0', border_width: 0.5, background: '#f8fafc' }),
    TEXT('rh_card_lbl', 'report_header', 97, 29, 30, 5, 'MÜŞTERİ', { bold: true, font_size: 8, color: '#64748b' }),
    FIELD('rh_card_title', 'report_header', 97, 33, 87, 5, 'main', 'account_title',
      { font_size: 11, bold: true, color: '#1a2332' }),
    FIELD('rh_card_addr',  'report_header', 97, 39, 87, 4, 'main', 'account_address', { font_size: 8 }),
    EXPR('rh_card_city',   'report_header', 97, 43, 87, 4,
      "[account_district] + ' / ' + [account_city]", { font_size: 8, data_source: 'main' }),
    TEXT('rh_card_lbl_tel', 'report_header', 97, 47, 12, 4, 'Tel:', { font_size: 8, bold: true, color: '#64748b' }),
    FIELD('rh_card_tel',    'report_header', 110, 47, 35, 4, 'main', 'account_phone',    { font_size: 8 }),
    TEXT('rh_card_lbl_vkn', 'report_header', 145, 47, 10, 4, 'VKN:',{ font_size: 8, bold: true, color: '#64748b' }),
    FIELD('rh_card_vkn',    'report_header', 156, 47, 28, 4, 'main', 'account_tax_number', { font_size: 8 }),
    TEXT('rh_card_lbl_em',  'report_header', 97, 51, 17, 4, 'E-posta:', { font_size: 8, bold: true, color: '#64748b' }),
    FIELD('rh_card_email',  'report_header', 115, 51, 70, 4, 'main', 'account_email',  { font_size: 8 }),

    // ──── PAGE HEADER (tablo başlığı) ─────────────────────────────
    RECT('ph_bg', 'page_header', 0, 0, 186, 10, { background: '#1d6ef5', border_color: '#1d6ef5', border_width: 0 }),
    TEXT('ph_h_no',    'page_header', 1,   2, 8,   6, '#',               { font_size: 9, bold: true, color: '#ffffff', align: 'center' }),
    TEXT('ph_h_name',  'page_header', 10,  2, 80,  6, 'ÜRÜN / HİZMET',   { font_size: 9, bold: true, color: '#ffffff' }),
    TEXT('ph_h_qty',   'page_header', 92,  2, 18,  6, 'MİKTAR',          { font_size: 9, bold: true, color: '#ffffff', align: 'right' }),
    TEXT('ph_h_price', 'page_header', 112, 2, 24,  6, 'BİRİM FİYAT',     { font_size: 9, bold: true, color: '#ffffff', align: 'right' }),
    TEXT('ph_h_vat',   'page_header', 138, 2, 14,  6, 'KDV %',           { font_size: 9, bold: true, color: '#ffffff', align: 'right' }),
    TEXT('ph_h_total', 'page_header', 154, 2, 30,  6, 'TUTAR',           { font_size: 9, bold: true, color: '#ffffff', align: 'right' }),

    // ──── DETAIL (her satır için tekrar eder) ────────────────────
    FIELD('d_no',    'detail', 1,   1, 8,  6, 'detail', 'line_no',     { font_size: 9, align: 'center' }),
    FIELD('d_name',  'detail', 10,  1, 80, 6, 'detail', 'stock_name',  { font_size: 9 }),
    FIELD('d_qty',   'detail', 92,  1, 18, 6, 'detail', 'quantity',    { font_size: 9, align: 'right', format: '#,##0.00' }),
    FIELD('d_price', 'detail', 112, 1, 24, 6, 'detail', 'unit_price',  { font_size: 9, align: 'right', format: '#,##0.00' }),
    FIELD('d_vat',   'detail', 138, 1, 14, 6, 'detail', 'vat_rate',    { font_size: 9, align: 'right', format: '#,##0' }),
    FIELD('d_total', 'detail', 154, 1, 30, 6, 'detail', 'line_total',  { font_size: 10, bold: true, align: 'right', format: '#,##0.00' }),
    LINE('d_sep',    'detail', 0, 7.5, 186, '#e2e8f0', 0.3),

    // ──── REPORT FOOTER (toplamlar + imzalar) ────────────────────
    // Not (sol)
    TEXT('rf_lbl_note', 'report_footer', 2, 2, 30, 5, 'Notlar:',  { bold: true, font_size: 9, color: '#64748b' }),
    FIELD('rf_note',    'report_footer', 2, 7, 100, 20, 'main', 'notes', { font_size: 8, color: '#475569' }),

    // Toplam kutusu (sağ)
    RECT('rf_box', 'report_footer', 108, 0, 78, 36, { border_color: '#1d6ef5', border_width: 0.5, background: '#f8fafc' }),

    TEXT('rf_lbl_sub',   'report_footer', 110, 2, 38, 5, 'Ara Toplam:',  { bold: true, font_size: 9, align: 'right', color: '#475569' }),
    FIELD('rf_sub',      'report_footer', 148, 2, 36, 5, 'main', 'subtotal',       { align: 'right', format: '#,##0.00' }),

    TEXT('rf_lbl_disc',  'report_footer', 110, 8, 38, 5, 'İskonto Toplam:', { bold: true, font_size: 9, align: 'right', color: '#475569' }),
    FIELD('rf_disc',     'report_footer', 148, 8, 36, 5, 'main', 'discount_total', { align: 'right', format: '#,##0.00' }),

    TEXT('rf_lbl_vat',   'report_footer', 110, 14, 38, 5, 'KDV Toplam:', { bold: true, font_size: 9, align: 'right', color: '#475569' }),
    FIELD('rf_vat',      'report_footer', 148, 14, 36, 5, 'main', 'vat_total',     { align: 'right', format: '#,##0.00' }),

    LINE('rf_sep', 'report_footer', 110, 20.5, 74, '#1d6ef5', 1),

    TEXT('rf_lbl_grand', 'report_footer', 110, 22, 38, 7, 'GENEL TOPLAM:', { bold: true, font_size: 12, align: 'right', color: '#1d6ef5' }),
    FIELD('rf_grand',    'report_footer', 148, 22, 36, 7, 'main', 'grand_total',   { font_size: 12, bold: true, align: 'right', format: '#,##0.00', color: '#1d6ef5' }),

    TEXT('rf_lbl_cur',   'report_footer', 110, 30, 38, 4, 'Para Birimi:', { font_size: 8, align: 'right', color: '#64748b' }),
    FIELD('rf_cur',      'report_footer', 148, 30, 36, 4, 'main', 'currency_code', { font_size: 8, align: 'right', color: '#64748b' }),

    // İmza alanları (en altta)
    LINE('rf_sig_l',  'report_footer', 5,   42, 50, '#64748b', 0.3),
    LINE('rf_sig_r',  'report_footer', 130, 42, 50, '#64748b', 0.3),
    TEXT('rf_sig_l_lbl', 'report_footer', 5,   43, 50, 5, 'Hazırlayan',     { font_size: 9, align: 'center', color: '#475569' }),
    TEXT('rf_sig_r_lbl', 'report_footer', 130, 43, 50, 5, 'Müşteri / Yetkili İmza', { font_size: 9, align: 'center', color: '#475569' }),

    // ──── PAGE FOOTER ────────────────────────────────────────────
    LINE('pf_top', 'page_footer', 0, 0, 186, '#cbd5e1', 0.3),
    // Format: "Sayfa <toplam> / <aktif>" — ilk rakam toplam, ikinci aktif sayfa
    EXPR('pf_page', 'page_footer', 0, 2, 186, 5,
      "'Sayfa ' + [total_pages] + ' / ' + [page_number]",
      { data_source: 'context', font_size: 8, align: 'center', color: '#64748b' }),
  ],
};

// Diğer belge tipleri için aynı şablonu klonlayıp başlık değiştirebiliriz.
function cloneWithTitle(base, title) {
  const next = JSON.parse(JSON.stringify(base));
  const titleEl = next.elements.find(e => e.id === 'rh_title');
  if (titleEl) titleEl.text = title;
  return next;
}

export const DEFAULT_LAYOUTS = {
  sales_quote:      cloneWithTitle(SALES_QUOTE_STANDARD, 'VERİLEN TEKLİF'),
  purchase_quote:   cloneWithTitle(SALES_QUOTE_STANDARD, 'ALINAN TEKLİF'),
  sales_invoice:    cloneWithTitle(SALES_QUOTE_STANDARD, 'SATIŞ FATURASI'),
  purchase_invoice: cloneWithTitle(SALES_QUOTE_STANDARD, 'ALIŞ FATURASI'),
  sales_waybill:    cloneWithTitle(SALES_QUOTE_STANDARD, 'SATIŞ İRSALİYESİ'),
  purchase_waybill: cloneWithTitle(SALES_QUOTE_STANDARD, 'ALIŞ İRSALİYESİ'),
  sales_order:      cloneWithTitle(SALES_QUOTE_STANDARD, 'ALINAN SİPARİŞ'),
  purchase_order:   cloneWithTitle(SALES_QUOTE_STANDARD, 'VERİLEN SİPARİŞ'),
};

export function getDefaultLayout(docType) {
  return DEFAULT_LAYOUTS[docType] || DEFAULT_LAYOUTS.sales_quote;
}
